// Mirrors the backend's utils/slug.js slugify - keep both in sync.
// "Rajesh Setty" -> "rajesh.setty"
const toSlug = (value: string, disallowed: RegExp) =>
  value
    .replace(disallowed, "")
    .replace(/\s+/g, ".")
    .replace(/\.+/g, ".")
    .replace(/^\.+|\.+$/g, "");

export function slugify(name: string): string {
  const value = name.trim().toLowerCase();
  const asciiSlug = toSlug(value, /[^a-z0-9\s.]/g);
  if (asciiSlug) return asciiSlug;
  // Names with no Latin letters (e.g. Tamil "ஔவையார்") used to slugify to ""
  // and so had no author/tag page. Keep their own letters instead. Only
  // used when the ASCII slug is empty, so every existing slug is unchanged.
  return toSlug(value.normalize("NFC"), /[^\p{L}\p{M}\p{N}\s.]/gu);
}

// Kept as an alias so existing author-page call sites read clearly.
export const slugifyAuthor = slugify;
